import { useTranslation } from 'react-i18next';
import { 
  GENRES, 
  SKILLS, 
  BAND_STATUSES, 
  MUSICIAN_STATUSES,
  GENRE_TRANSLATION_KEYS,
  SKILL_TRANSLATION_KEYS,
  BAND_STATUS_TRANSLATION_KEYS,
  MUSICIAN_STATUS_TRANSLATION_KEYS
} from '../constants/music';

/**
 * Hook to get translated music constants
 */
export function useMusicTranslations() {
  const { t } = useTranslation();

  const getTranslatedGenres = () => {
    return GENRES.map(genre => ({
      value: genre,
      label: t(GENRE_TRANSLATION_KEYS[genre], genre), // Fallback to original if translation missing
    }));
  };

  const getTranslatedSkills = () => {
    return SKILLS.map(skill => ({
      value: skill,
      label: t(SKILL_TRANSLATION_KEYS[skill], skill),
    }));
  };

  const getTranslatedBandStatuses = () => {
    return BAND_STATUSES.map(status => ({
      value: status,
      label: t(BAND_STATUS_TRANSLATION_KEYS[status], status),
    }));
  };

  const getTranslatedMusicianStatuses = () => {
    return MUSICIAN_STATUSES.map(status => ({
      value: status,
      label: t(MUSICIAN_STATUS_TRANSLATION_KEYS[status], status),
    }));
  };

  const translateGenre = (genre: string) => {
    return t(GENRE_TRANSLATION_KEYS[genre as keyof typeof GENRE_TRANSLATION_KEYS], genre);
  };

  const translateSkill = (skill: string) => {
    return t(SKILL_TRANSLATION_KEYS[skill as keyof typeof SKILL_TRANSLATION_KEYS], skill);
  };

  const translateBandStatus = (status: string) => {
    return t(BAND_STATUS_TRANSLATION_KEYS[status as keyof typeof BAND_STATUS_TRANSLATION_KEYS], status);
  };

  const translateMusicianStatus = (status: string) => {
    return t(MUSICIAN_STATUS_TRANSLATION_KEYS[status as keyof typeof MUSICIAN_STATUS_TRANSLATION_KEYS], status);
  };

  return {
    getTranslatedGenres,
    getTranslatedSkills,
    getTranslatedBandStatuses,
    getTranslatedMusicianStatuses,
    translateGenre,
    translateSkill,
    translateBandStatus,
    translateMusicianStatus,
  };
}